import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-22f53994"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "information" }
const _hoisted_2 = { style: {"display":"flex"} }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " *", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "username" }, "用户名", -1))
const _hoisted_5 = { style: {"display":"flex"} }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "phone" }, "手机号", -1))
const _hoisted_7 = { class: "number" }
const _hoisted_8 = { style: {"display":"flex"} }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "name" }, "姓名", -1))
const _hoisted_10 = {
  key: 0,
  class: "names"
}
const _hoisted_11 = {
  key: 0,
  class: "self"
}
const _hoisted_12 = {
  key: 1,
  class: "selfs"
}
const _hoisted_13 = { style: {"display":"flex"} }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "companyname" }, "公司名称", -1))
const _hoisted_15 = {
  key: 0,
  class: "companys"
}
const _hoisted_16 = {
  key: 0,
  class: "firm"
}
const _hoisted_17 = {
  key: 1,
  class: "selfs"
}
const _hoisted_18 = {
  key: 1,
  class: "selfs"
}
const _hoisted_19 = { style: {"display":"flex"} }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "profession" }, "职业", -1))
const _hoisted_21 = { class: "list" }
const _hoisted_22 = { style: {"display":"flex"} }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tool" }, "常用软件", -1))
const _hoisted_24 = { class: "toolname" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_form, {
      ref: "ruleFormRef",
      model: _ctx.informationForm,
      rules: _ctx.rules,
      class: "demo-ruleForm",
      "status-icon": ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _hoisted_4,
          _createVNode(_component_el_input, {
            modelValue: _ctx.informationForm.username,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.informationForm.username) = $event)),
            placeholder: "请输入1-20位的用户名",
            "show-word-limit": "",
            type: "text",
            class: "usernameinput",
            maxlength: "20"
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.userinfot.mobile), 1)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          (_ctx.userinfot.name != '')
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.userinfot.name), 1))
            : _createCommentVNode("", true),
          _createVNode(_component_el_form_item, { prop: "name" }, {
            default: _withCtx(() => [
              (_ctx.userinfot.name == '')
                ? (_openBlock(), _createBlock(_component_el_input, {
                    key: 0,
                    modelValue: _ctx.informationForm.name,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.informationForm.name) = $event)),
                    placeholder: "请输入姓名",
                    class: "nameinput"
                  }, null, 8, ["modelValue"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, { to: "/user/selfverify" }, {
            default: _withCtx(() => [
              (
              _ctx.getInformation.data.identification != 3 &&
              _ctx.getInformation.data.pid == 0
            )
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, " 个人认证>> "))
                : _createCommentVNode("", true),
              (_ctx.getInformation.data.identification == 3)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, " 已个人认证 "))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_13, [
          _hoisted_14,
          (_ctx.userinfot.company != '')
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(_ctx.userinfot.company), 1))
            : _createCommentVNode("", true),
          _createVNode(_component_el_form_item, {
            prop: "company",
            class: "company"
          }, {
            default: _withCtx(() => [
              (_ctx.userinfot.company == '')
                ? (_openBlock(), _createBlock(_component_el_input, {
                    key: 0,
                    modelValue: _ctx.informationForm.company,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.informationForm.company) = $event)),
                    placeholder: "请输入您所在的公司名称",
                    class: "companynameinput"
                  }, null, 8, ["modelValue"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, { to: "/user/firmverify" }, {
            default: _withCtx(() => [
              (_ctx.getInformation.data.company_id == null)
                ? (_openBlock(), _createElementBlock("div", _hoisted_16, " 企业认证>> "))
                : _createCommentVNode("", true),
              (
              _ctx.getInformation.data.company_id != null &&
              _ctx.getInformation.data.pid == 0
            )
                ? (_openBlock(), _createElementBlock("div", _hoisted_17, " 已企业认证 "))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          (
            _ctx.getInformation.data.company_id != null &&
            _ctx.getInformation.data.pid != 0
          )
            ? (_openBlock(), _createElementBlock("div", _hoisted_18, " 已企业认证 "))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_19, [
          _hoisted_20,
          _createElementVNode("div", _hoisted_21, [
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _ctx.informationForm.vocation,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.informationForm.vocation) = $event)),
                  placeholder: "请选择您的职业",
                  class: "job"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      label: "学生",
                      value: "学生"
                    }),
                    _createVNode(_component_el_option, {
                      label: "采购/销售/渠道运营",
                      value: "采购/销售/渠道运营"
                    }),
                    _createVNode(_component_el_option, {
                      label: "企业管理者",
                      value: "企业管理者"
                    }),
                    _createVNode(_component_el_option, {
                      label: "自动化工程师",
                      value: "自动化工程师"
                    }),
                    _createVNode(_component_el_option, {
                      label: "机械设计工程师",
                      value: "机械设计工程师"
                    }),
                    _createVNode(_component_el_option, {
                      label: "机械研发工程师",
                      value: "机械研发工程师"
                    }),
                    _createVNode(_component_el_option, {
                      label: "机械设备工程师",
                      value: "机械设备工程师"
                    }),
                    _createVNode(_component_el_option, {
                      label: "机械装配工程师",
                      value: "机械装配工程师"
                    }),
                    _createVNode(_component_el_option, {
                      label: "仪器/仪表/计量工程师",
                      value: "仪器/仪表/计量工程师"
                    }),
                    _createVNode(_component_el_option, {
                      label: "通信技术工程师",
                      value: "通信技术工程师"
                    }),
                    _createVNode(_component_el_option, {
                      label: "电气工程师",
                      value: "电气工程师"
                    }),
                    _createVNode(_component_el_option, {
                      label: "电子技术研发工程师",
                      value: "电子技术研发工程师"
                    }),
                    _createVNode(_component_el_option, {
                      label: "硬件工程师",
                      value: "硬件工程师"
                    }),
                    _createVNode(_component_el_option, {
                      label: "软件工程师",
                      value: "软件工程师"
                    }),
                    _createVNode(_component_el_option, {
                      label: "其他",
                      value: "其他"
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_22, [
          _hoisted_23,
          _createElementVNode("div", _hoisted_24, [
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_checkbox_group, {
                  modelValue: _ctx.informationForm.type,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.informationForm.type) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_checkbox, {
                      label: "Soildworks",
                      checked: _ctx.checkboxshow('Soildworks'),
                      name: "type"
                    }, null, 8, ["checked"]),
                    _createVNode(_component_el_checkbox, {
                      label: "Pro/E",
                      checked: _ctx.checkboxshow('Pro/E'),
                      name: "type"
                    }, null, 8, ["checked"]),
                    _createVNode(_component_el_checkbox, {
                      label: "Femap",
                      checked: _ctx.checkboxshow('Femap'),
                      name: "type"
                    }, null, 8, ["checked"]),
                    _createVNode(_component_el_checkbox, {
                      label: "UG",
                      checked: _ctx.checkboxshow('UG'),
                      name: "type"
                    }, null, 8, ["checked"]),
                    _createVNode(_component_el_checkbox, {
                      label: "MoldFlow",
                      checked: _ctx.checkboxshow('MoldFlow'),
                      name: "type"
                    }, null, 8, ["checked"]),
                    _createVNode(_component_el_checkbox, {
                      label: "Matalb",
                      checked: _ctx.checkboxshow('Matalb'),
                      name: "type"
                    }, null, 8, ["checked"]),
                    _createVNode(_component_el_checkbox, {
                      label: "Workbench",
                      checked: _ctx.checkboxshow('Workbench'),
                      name: "type"
                    }, null, 8, ["checked"]),
                    _createVNode(_component_el_checkbox, {
                      label: "CAXA",
                      checked: _ctx.checkboxshow('CAXA'),
                      name: "type"
                    }, null, 8, ["checked"]),
                    _createVNode(_component_el_checkbox, {
                      label: "Catia",
                      checked: _ctx.checkboxshow('Catia'),
                      name: "type"
                    }, null, 8, ["checked"]),
                    _createVNode(_component_el_checkbox, {
                      label: "Ansys",
                      checked: _ctx.checkboxshow('Ansys'),
                      name: "type"
                    }, null, 8, ["checked"])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            })
          ])
        ]),
        _createVNode(_component_el_button, {
          type: "primary",
          class: "submit routine",
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.submitForm(_ctx.ruleFormRef)))
        }, {
          default: _withCtx(() => [
            _createTextVNode("提交")
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model", "rules"])
  ]))
}